import { render, staticRenderFns } from "./CreateShashaAd.vue?vue&type=template&id=3012c54a&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml&"
import script from "./CreateShashaAd.vue?vue&type=script&lang=ts&"
export * from "./CreateShashaAd.vue?vue&type=script&lang=ts&"
import style0 from "./CreateShashaAd.vue?vue&type=style&index=0&id=3012c54a&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3012c54a",
  null
  
)

export default component.exports